import { Fragment, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  ListItem,
  ListItemLabelWrapper,
  ListItemLabel,
  ListItemOrder
} from './list-item';
import { getAppLocale } from 'utils/locale';
import { StoreContext } from 'index';
import { Button } from 'components/button';
import Icon from 'components/icon/Icon';
import RefactoredListBody from './RefactoredListBody';
import RefactoredList from './RefactoredList';

const SportsList = ({
  items = [],
  defaultVisibleItems = 10,
  labelShowMore = 'show More',
  labelShowLess = 'show Less'
}) => {
  const {
    uiState: { locale }
  } = useContext(StoreContext);
  const [showAll, setShowAll] = useState(false);

  return (
    <RefactoredList>
      <RefactoredListBody twoColumns>
        {items.map((result, i) => (
          <Fragment key={i}>
            {(showAll || i < defaultVisibleItems) && (
              <ListItem small>
                <ListItemOrder>{i + 1}</ListItemOrder>
                <ListItemLabelWrapper>
                  <ListItemLabel label>
                    {result.name ||
                      result.title?.[getAppLocale(locale)] ||
                      result.title?.code}
                  </ListItemLabel>
                </ListItemLabelWrapper>
              </ListItem>
            )}
          </Fragment>
        ))}
      </RefactoredListBody>
      {items.length > defaultVisibleItems && (
        <Button
          rounded
          grey
          onClick={() => setShowAll(!showAll)}
          extraClassNames={'u-margin-auto'}
        >
          <Icon id={!showAll ? 'dropdown-open' : 'dropdown-closed'} />
          {showAll ? labelShowLess : labelShowMore}
        </Button>
      )}
    </RefactoredList>
  );
};

export default SportsList;
